
import { combineReducers } from 'redux';
import {postsReducer} from './postsReducer';
import {authReducer} from './authReducer';

//getting all reducers & combine them to one to pass it to the store
const reducers = combineReducers({ 
    postsReducer : postsReducer,
    authReducer : authReducer ,   
});

export default reducers ;